import React from "react";

interface LayoutProps {
  children: React.ReactNode;
  width?: string;
}

export function Layout({ children, width = "800px" }: LayoutProps) {
  return (
    <div
      className="container-fluid min-vh-100 d-flex align-items-center justify-content-center surface-dim"
      style={{ minWidth: width }}
    >
      <div className="card shadow" style={{ width, height: "400px" }}>
        <div className="card-body d-flex p-0">
          <div className="d-flex flex-grow-1 p-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
